import * as THREE from 'three';

const _frustum = new THREE.Frustum();
const _projScreenMatrix = new THREE.Matrix4();

/**
 * @param {THREE.Camera} camera
 * @param {{ minX: number; maxX: number; minZ: number; maxZ: number }[]} regions
 */
export function countFrustumVisibleRegions(camera, regions) {
  _projScreenMatrix.multiplyMatrices(
    camera.projectionMatrix,
    camera.matrixWorldInverse,
  );
  _frustum.setFromProjectionMatrix(_projScreenMatrix);

  let visible = 0;
  const box = new THREE.Box3();
  for (const r of regions) {
    box.min.set(r.minX, 0, r.minZ);
    box.max.set(r.maxX, 28, r.maxZ);
    if (_frustum.intersectsBox(box)) visible += 1;
  }
  return visible;
}
